
import { defineComponent } from 'vue';
import ATypography from 'ant-design-vue/es/typography';

export default defineComponent({
  components: {
    ATypographyLink: ATypography.Link,
  },
});
